<template>
  <div class="topic">
    <el-container>
      <el-main class="main">
        <div class="container">
          <div style="margin:10px 0px">
            <search-andselect></search-andselect>
          </div>
          <div class="mainTop">
            <allTopic :special="specialGroup" :specialLabel="specialLabel" v-model="curSpecialType"></allTopic>
          </div>
          <div class="mainBottom">
            <loadButton v-model="page" v-if="loadButtonshow"></loadButton>
          </div>
        </div>
      </el-main>

      <el-footer v-if="hidefooter" :style="{'height':  footerHeight}">
        <help-footer v-if="this.webID == '111142'"></help-footer>
        <people-footer v-else-if="showPeople"></people-footer>
        <homeFooter v-else :logo="logo"></homeFooter>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
import searchAndselect from "../components/searchAndselect"; //搜索框
import homeFooterAd from "../components/homeFooterAd.vue"; //底部
import homeHeader from "@/components/homeHeader.vue"; //顶部
import allTopic from "@/components/allTopic.vue"; //专题
import loadButton from "@/components/loadButton.vue"; //加载按钮
import homeFooter from "@/components/homeFooter.vue"; //底部
import peopleFooter from "@/components/peopleFooter.vue"; //底部
import { mapActions, mapGetters } from "vuex";
import {
  getModuleInfo,
  getResource,
  getSpecialNode,
  newtitle,
  newtitle1
} from "../services/api.js";

export default {
  data() {
    return {
      loadButtonshow: true,
      isHeader: false,
      label: {
        id: "",
        list: [{ photo1: "", title: "" }]
      },
      logo: {
        id: "",
        list: [{ photo1: "" }]
      },
      special: {
        id: "",
        list: []
      },
      specialLabel: {
        id: "",
        list: [{ pid: 0 }]
      },
      page: 1,
      specialGroup: {},
      curSpecialType: "",
      opacity: "0.68",
      footerHeight: "316px"
    };
  },
  computed: {
    ...mapGetters([
      "modelsInfo",
      "webModels",
      "curModelInfo",
      "webID",
      "hidefooter",
      "isGaonS",
      "isEnglish",
      "showPeople"
    ]),
    channel_id() {
      return this.curModelInfo.id;
    }
  },

  mounted() {
    console.info("================", this.webID);
    switch (this.webID) {
      case "111142":
        this.footerHeight = "120px";
        break;
      case "111152":
        this.footerHeight = "auto";
        break;
      case "111111":
        this.footerHeight = "auto";
        break;
      default:
        this.footerHeight = "316px";
    }

    this.getModuleInfo();
  },
  watch: {
    channel_id() {
      this.getModuleInfo();
    },
    page(val) {
      this.getResource();
    },
    curSpecialType(val) {
      this.page = 1;

      this.getResource();
    },
    isEnglish() {
      this.loadButtonshow = false;
      this.loadButtonshow = true;
    }
  },
  methods: {
    getTitles() {
      //获取分类
      let totallist = [];
      newtitle({
        params: {
          customer_id: this.webID
        }
      }).then(res => {
        if (res) {
          if (res.status_code == 1) {
            var lis = res.data.list.filter(item => {
              return item.level == 1 && item.active == 1;
            });
            lis.forEach(item => {
              totallist.push({
                id: item.id,
                cname: item.cname,
                type: item.type
              });
            });
            newtitle1({
              params: {
                customer_id: this.webID
              }
            }).then(res => {
              if (res) {
                if (res.status_code == 1) {
                  var lis = res.data.list.filter(item => {
                    return item.level == 1 && item.active == 1;
                  });
                  lis.forEach(item => {
                    totallist.push({
                      id: item.id,
                      cname: item.cname,
                      type: item.type
                    });
                  });
                  var that = this;
                  totallist.forEach(item => {});
                }
              }
            });
          }
        }
      });
    },
    mosewheel(event) {
      let scrolltop =
        document.body.scrollTop ||
        document.documentElement.scrollTop ||
        window.pageYOffset;
      if (scrolltop == 0) {
        this.opacity = "0.68";
      } else {
        this.opacity = "1";
      }
    },
    getResource() {
      getResource(
        {
          customer_id: this.webID,
          category_view: this.curSpecialType
        },
        2,
        this.page
      ).then(res => {
        if (res.status_code == 1) {
          if (this.page == 1) {
            this.specialGroup = res.data;
          } else {
            this.specialGroup.data = this.specialGroup.data.concat(
              res.data.data
            );
          }
        } else {
          this.specialGroup = {};
          document.querySelector(".loadButton").children[0].innerHTML =
            "已经到底部啦";
        }
      });
    },
    getSpecialNode() {
      getSpecialNode({
        id: this.special.list[0].category_id
      }).then(res => {
        if (res.data) {
          res.data.list = res.data.list.filter(x => x.level == 1);
          // 增加人民视觉临时排序
          if (this.showPeople) {
            const sortBase = [27235, 27203, 27250, 27202, 27201, 27200];
            // const sortBase = [610, 609];

            const sortFunc = set => {
              const result = set.map(item => ({
                ...item,
                index: sortBase.findIndex(e => item.id === e)
              }));
              result.sort((a, b) => a.index - b.index);
              return result;
            };

            const resultSort = sortFunc(res.data.list);
            res.data.list = resultSort;

            this.specialLabel = res.data;
          } else {
            this.specialLabel = res.data;
          }
        }
      });
    },
    getModuleInfo() {
      var id = setInterval(() => {
        if (this.$store.getters.webModels.module_data) {
          clearInterval(id);
          var label = this.webModels.module_data.find(item => {
            if (item.title == "标签") return item;
          });
          var logo = this.webModels.module_data.find(item => {
            if (item.title == "logo") return item;
          });
          var special = this.webModels.module_data.find(item => {
            if (item.title == "专题频道") return item;
          });
          let data = {
            module_id: logo.id,
            web_id: this.webID,
            channel_id: this.channel_id //this.curModelInfo.id
          };
          let query = {
            page: 1,
            page_nums: logo.rows_num
          };
          getModuleInfo(data, query).then(res => {
            if (res.status_code == 1) {
              this.logo = {
                id: logo.id,
                list: res.data.list
              };
            }
          });
          data.module_id = label.id;
          query.page_nums = label.rows_num;
          getModuleInfo(data, query).then(res => {
            if (res.status_code == 1) {
              this.label = {
                id: label.id,
                list: res.data.list
              };
            }
          });
          data.module_id = special.id;
          query.page_nums = special.rows_num;
          getModuleInfo(data, query).then(res => {
            if (res.status_code == 1) {
              this.special = {
                id: special.id,
                list: res.data.list
              };
              this.curSpecialType = this.special.list[0].category_id;
              this.getResource();
              this.getSpecialNode();
            }
          });
        }
      }, 0);
    }
  },
  components: {
    homeHeader,
    homeFooter,
    allTopic,
    loadButton,
    homeFooterAd,
    searchAndselect,
    peopleFooter
  }
};
</script>
<style lang="less">
// .topic {
//   .el-header {
//     border-bottom: 1px solid #e7e7e7;
//   }
// }
</style>

<style lang="less" scoped>
.topic {
  .el-header {
    border-bottom: 1px solid #e7e7e7;
  }
  .homeHeader {
    background-color: #000;
  }

  .el-main {
    overflow: hidden;
  }
  .main {
    overflow: hidden;
    width: 100%;
    background: #ffff;
    padding: 0;
    .container {
      overflow: hidden;
      width: 1200px;
      padding-top: 10px;
    }
  }
  .mainBottom {
    width: 100%;
  }
  .el-footer {
    padding: 0px;
  }
}
</style>





// WEBPACK FOOTER //
// src/page/topic.vue